<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading || isPermitPrintInProgress" style="position: fixed; top: 0; left: 0; width: 100%;height: 100%;    z-index:99;">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage Permit Printing</b></h5>
    </div>
  </div>
  <hr>
  <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
    <legend class="scheduler-border tsk-display"><h5>1. Application Details</h5></legend>
    <div class="row">
      <div class="col-12">
        <table class="table table-borderless" border="0">
          <tbody>
            <tr class="">
              <td class="s-td" style="color: black;">
                <b>Account Number : </b>{{ctrlData?.data?.AccountNumber}}
              </td>
              <td class="s-td" style="color: black;">
                <b>Application Number : </b>{{ctrlData?.data?.ApplicationNumber}}
              </td>
            </tr>
            <tr>
              <td class="s-td" style="color: black;">
                <b>Reference Number : </b>{{ctrlData?.data?.PermitNumber}}
              </td>
              <td class="s-td" style="color: black;">
                <b>Status : </b> <span  style="color: red;">{{ctrlData?.data?.status_desc}}</span>
              </td>
              <td class="s-td" style="color: black;">
                <b>Approved By : </b> <span  style="color: red;">{{ctrlData?.data?.approvedBy}}</span>
              </td>
            </tr>
            <tr>
              <td class="s-td" style="color: black;" >
              <b>Application Date : </b>{{ctrlData?.data?.date_created?.toLocaleString() | date:'dd/MM/y'}}
              </td>
              <td class="s-td" style="color: black;">
                <b>Submission Date : </b>{{ctrlData?.data?.submission_date?.toLocaleString() | date:'dd/MM/y'}}
              </td>
            </tr>
            <tr>
              <td td class="s-td" style="color: black;">
              <b>Route Summary : </b>{{ctrlData?.data?.route_summary}}
              </td>
              <td class="s-td" style="color: black;">
                <b>Permit Type : </b>{{ctrlData?.data?.PermitType}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </fieldset>
  <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
    <legend class="scheduler-border tsk-display"><h5>2. Route Details</h5></legend>
    <form [formGroup]="form">
      <!-- <div class="col-sm-12 p-0 mt-2" style="margin:0px;padding:0px;"><legend class="scheduler-border tsk-display" style="margin:0px;padding:0px;"><h5>2. Route Details</h5> -->
        <textarea #routeDetail oninput="this.style.height = ''; this.style.height = this.scrollHeight +'px'" wrap="hard" title="Route Details" [ngModel]="ctrlData?.data?.route_detail" (input)="changes()" [style.height]="routeDetailHeight + 'px'" style="overflow-y:hidden;" formControlName="route_detail">
        </textarea>
        <br>
        <button title="Update Route Details" name="saveroutedetails" type="submit" id="btnSave" (click)="updateRouteForApproval()"  class="btn btn-md m-clr pull-right hd-btn myButton" style="width:auto; margin-right:0px;margin-bottom:5px;  ">Update Route Details</button>
      
    <!-- </div> -->
    </form>
  </fieldset>
  <br>
  

  <fieldset *ngIf="ctrlData.data.permit_type.timetable_reqd" class="scheduler-border" style="margin:0px;padding:0px;">
    <legend class="scheduler-border tsk-display"><h5>2.1 Time Table Details</h5></legend>    
    <div class="col-md-12 p-0">
      <app-timetable [dataCntrl]="ctrlData" isApproval = "true"></app-timetable>
    </div>
  </fieldset>

  <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
    <legend class="scheduler-border tsk-display"><h5>3. Approved Permits</h5></legend>
    <div class="row" style="margin:4px auto!important;padding:0px">
      <div class="col-12" style="margin:0px!important;padding:0px!important;">
        <table class="table tbl-stl table-sm" border="1" style="width:100%;">
          <thead class="thead-inverse">
            <tr class="hd-clpse">
              <th  class="tbl-hd-stl">
                Permit Number
              </th>
              <th>
                Issue Number
              </th>  
              <th class="tbl-hd-stl">
                Status
              </th>   
              <th class="tbl-hd-stl">
                Printed By
              </th>            
              <th>
                Vehicle Type
              </th>
              <th>
                Registration Number
              </th> 
              <th>
                Number Of Passangers
              </th>                
              <th>
                Date Valid From 
              </th>
              <th>
                Date Valid To 
              </th>
              <th>
                Number of Days
              </th>     
              <th>
                Face Value Number
              </th> 
            
            </tr>
          </thead>
          <tbody>
            <tr class="tbl-row" *ngFor="let item of ctrlData.data.Permits | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count}; let i=index;">
              <td class="bfr-end-col">{{item.PermitNumber}}</td>
              <td class="bfr-end-col">/{{item.permit_issue}}</td>
              <td class="longtext bfr-end-col" title="{{item.Status}}">{{item.Status}}</td> 
              <td class="longtext bfr-end-col" title="{{item.printedBy}}">{{item.printedBy}}</td>           
              <td class="bfr-end-col">{{item.VehicleType}}</td>
              <td class="bfr-end-col">
                <input type="text"  class="form-control form-control-sm" [(ngModel)]="item.RegNumber" /> 
              </td>    
              <td class="bfr-end-col">
                <input type="text"  class="form-control form-control-sm" [(ngModel)]="item.NumberOfPassengers" /> 
                
              </td>        
              <td class="bfr-end-col" *ngIf="isRenewal(item.Renewal_num)">
                {{item.DateValidFrom?.toLocaleString() | date:'dd/MM/y'}}
                <input type="hidden" [ngModel]="item.DateValidFrom | date:'yyyy-MM-dd'" name="DateValidFrom" /> 
              </td>
              <td class="bfr-end-col" *ngIf="!isRenewal(item.Renewal_num)">             
              <input type="date" style="margin:0px;padding:0px;" title="Date From" [ngModel]="item.DateValidFrom | date:'yyyy-MM-dd'" min="{{this.currentDate | date:'yyyy-MM-dd'}}"  (ngModelChange)="onDateSelect( $event, item, 'DateValidFrom') " id="validDateFrom" class="form-control form-control-sm" /> 
              </td>
              <!-- <td class="bfr-end-col" *ngIf="isRenewal(item.Renewal_num)">               
                <input type="date" style="margin:0px;padding:0px;" title="Date To" data-date-format="yyyy-MM-dd"  [ngModel]="item.DateValidTo | date:'yyyy-MM-dd'" min="{{this.currentDate | date:'yyyy-MM-dd'}}" max="{{item.MaxDate | date:'yyyy-MM-dd'}}" (ngModelChange)="onDateSelect( $event, item, 'DateValidTo')" id="validDateTo" class="form-control form-control-sm" /> 
              </td> -->
              <td class="bfr-end-col">
                <input  [disabled] = "item.isEndDateValid"  type="date" style="margin:0px;padding:0px;" title="Date To" data-date-format="yyyy-MM-dd"  [ngModel]="item.DateValidTo | date:'yyyy-MM-dd'" min="{{this.currentDate | date:'yyyy-MM-dd'}}" max="{{item.MaxDate | date:'yyyy-MM-dd'}}" (ngModelChange)="onDateSelect( $event, item, 'DateValidTo')" id="validDateTo" class="form-control form-control-sm"  />
              </td>
              <td class="bfr-end-col" >
                <label ><span [ngStyle]="{'color': !item.isEndDateValid ? 'red' : 'green'}" >{{item.NumberOfDays}}</span></label>
              </td>
              <td class="bfr-end-col">
                <!--  <input type="text" [disabled]="isPrintingDone(item)" class="form-control form-control-sm" onlyNumber [(ngModel)]="item.FaceValueNumber"/> -->
                <input type="text" [disabled] = "!item.isEndDateValid" class="form-control form-control-sm" onlyNumber [(ngModel)]="item.FaceValueNumber"/>
              </td>
          
            <td class="btn-show end-col"  style="width:20%!important;">
              <button title = "Add Special Condition" name="special" class="btn btn-sm m-clr pull-left mr-2 myButton"(click)="openModal(item,i)" [disabled]="isReprintUser(item)"><i class="fa fa-gavel"></i></button>
              <button  title = "Save Valid To Date" name="special" class="btn btn-sm m-clr pull-left mr-2 myButton"(click)="UpdateDate(item)"><i class="fa fa-floppy-o"></i></button>
              <button  title="Print permits" style="color:white;margin:0px!important;" class="btn btn-secondary btn-sm pull-left myButton" (click)="permitPrint(item)" [disabled]="isReprintUser(item)"><i class="fa fa-print" aria-hidden="true"></i> </button>
              <button  title = "View Printed Permit" name="special" style="margin-left:1px!important" class="btn btn-sm m-clr pull-left mr-2 myButton"(click)="viewPrintedPermit(item.ID)"><i class="fa fa-eye"></i></button>
<!--              <button  *ngIf="item.document_guid !== null" title = "Revoke This Permit" name="special" style="margin-left:1px!important" class="btn btn-sm m-clr pull-left mr-2 myButton"(click)="issuePermitRevocation(item)"><i class="fa fa-close"></i></button>-->
            </td>
            </tr>
          </tbody>
          <tbody>
            <td> </td>
        </tbody>
          <tfoot style="padding:0px;margin:0px;">
            <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
              <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
                <div class="row">
                  <div class="col-2">
                    <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                      <div class="input-group-prepend">
                        <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                      </div>
                      <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize">

                        <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-8 text-center">
                    <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="isEmpty">
              <td colspan="4" class="rm-brd">
                <span class="text-info text-small">No permit applications found.</span>
              </td>
            </tr>
            <tr style="border:none !important">
              <td colspan="8" style="border:none !important"></td>  <td style="border:none !important"></td>
              <td style="border:none !important"></td>
              <td *ngIf="this.ctrlData.data.permit_type.permit_years != 5" class="btn-show rm-brd" style="width:110px!important;border: none;"> 
              <button title="Close" (click)="changeView(1)" type="submit" id="btnSaveRouteDetails" class="btn btn-sm m-clr pull-right myButton" style="color: white; width:80px; margin-bottom:5px; float: right ">Close</button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </fieldset>

  <fieldset *ngIf="ctrlData.data.permit_type.permit_years == 5" class="scheduler-border" style="margin:0px;padding:0px;">
    <legend class="scheduler-border tsk-display"><h5>4. Compliance Certificates</h5></legend>
    <div class="row" style="margin:4px auto!important;padding:0px">
      <div class="col-12" style="margin:0px!important;padding:0px!important;">
        <table class="table tbl-stl table-sm" border="1" style="width:100%;">
          <thead class="thead-inverse">
            <tr class="hd-clpse">
              <th  class="tbl-hd-stl">
                Permit Number
              </th>
              <th>
                Issue Year
              </th>  
              <th class="tbl-hd-stl">
                Status
              </th>  
              <th class="tbl-hd-stl">
                Printed By
              </th>   
              <th>
                Registration Number
              </th> 
              <th>
                Date Valid To 
              </th>
                
              <th>
                Face Value Number
              </th> 
            
            </tr>
          </thead>
          <tbody>
            <tr class="tbl-row" *ngFor="let item of complianceCertficateList | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count}; let i=index;">
              <td class="bfr-end-col">{{item.PermitNumber}}</td>
              <td class="bfr-end-col">/{{item.Year}}</td>
              <td class="longtext bfr-end-col" title="{{item.ComplianceStatusDescription}}">{{item.ComplianceStatusDescription}}</td>   
              <td class="longtext bfr-end-col" title="{{item.PrintedBy}}">{{item.PrintedBy}}</td>
              <td class="bfr-end-col">                
                <input type="text"  class="form-control form-control-sm" [(ngModel)]="item.RegistrationNumber" /> 
              </td> 
              <td class="bfr-end-col"> 
                {{item.ComplianceEndDate?.toLocaleString() | date:'dd/MM/y'}}
              </td>
                        
                      
            <td class="bfr-end-col">
              <input type="text" class="form-control form-control-sm" [disabled] = "isCertificatePrintingDone(item)"  [(ngModel)]="item.FaceValueNumber"/>
            </td>
          
            <td class="btn-show end-col"  style="width:20%!important;">
              
              <button  title="Print certificate" style="color:white;margin:0px!important;width:80px;" class="btn btn-secondary btn-sm pull-left myButton" (click)="permitPrintCompliance(item)" ><i class="fa fa-print" aria-hidden="true"></i> Print</button>
              <button  title = "View Printed Certificate" name="special" style="margin-left:1px!important" class="btn btn-sm m-clr pull-left mr-2 myButton"(click)="viewPrintedPermit(item.ID)"><i class="fa fa-eye"></i></button>
            </td>
            </tr>
          </tbody>
          <tbody>
            <td> </td>
        </tbody>
          <tfoot style="padding:0px;margin:0px;">
            <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
              <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
                <div class="row">
                  <div class="col-2">
                    <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                      <div class="input-group-prepend">
                        <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                      </div>
                      <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize">

                        <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-8 text-center">
                    <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="isEmpty">
              <td colspan="4" class="rm-brd">
                <span class="text-info text-small">No permit applications found.</span>
              </td>
            </tr>
            <tr style="border:none !important">
              <td colspan="8" style="border:none !important"></td>  <td style="border:none !important"></td>
              <td style="border:none !important"></td>
              <td class="btn-show rm-brd" style="width:110px!important;border: none;"> 
              <button title="Close" (click)="changeView(1)" type="submit" id="btnSave" class="btn btn-sm m-clr pull-right myButton" style="color: white; width:80px; margin-bottom:5px; float: right ">Close</button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </fieldset>


  <button style="width: 0px; display: none;"  id="showManager" data-toggle="modal" data-target="#Manager" visibility="hidden">
  </button>

  <!--Special conditions modal-->
  <div class="modal fade" id="Manager" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4>Add Special conditions to permit annexure</h4>
          <button type="button" class="close myButton" data-dismiss="modal" #closebutton aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-lg">
          <label class="mb-1">This will be printed in the Special Conditions section of the annexure to the permit.</label>
          <ckeditor  [(ngModel)]="description" (input)="changes()" debounce="100">
          </ckeditor>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-12">
              <button type="button" id="saveBt" [disabled]="description=='' || description==null" (click)="savePrintCondition()" style="color: white;" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton" >Save</button>
              <!-- <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" style="color: white;" (click)="onClose()">Close</button>                   -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">3. Permit Details</h5>
          <button type="button" class="close myButton" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-lg">

          <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;"
          [original-size]="false"
        [autoresize]="true"></pdf-viewer>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton" data-dismiss="modal">Close</button>
          <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
        </div>
      </div>
      
    </div>
    </div>
</div>
